export { default } from './Ptdoc';
